module.exports = __webpack_public_path__ + "static/media/Chart.c3e97f9f.png";